import { useState } from "react";
import AlertModal from "../../../components/alertModal/alertModal";
import CustomBreadcrumb from "../../../components/customBreadcrumb/CustomBreadcrumb";
import MainLoader from "../../../components/loading/MainLoader";
import ProductAndCircuitIdSelector from "../../../components/productAndCircuitIdSelector/ProductAndCircuitIdSelector";
import { ISelectOption } from "../../../components/selectOption/SelectOption";
import Title from "../../../components/title/Title";
import { EPackageType } from "../../../interfaces/packageType";
import NoneBroadbandReport from "./noneBroadbandReport/NoneBroadbandReport";

export const chartColors = [
  { platform: "facebook", color: "#1877f2" },
  { platform: "twitter", color: " #1da1f2" },
  { platform: "youtube", color: " #ff0000" },
  { platform: "likedin", color: "#0a66c2" },
  { platform: "instagram", color: "#c32aa3" },
  { platform: "tiktok", color: "#010101" },
  { platform: "google", color: "#4285f4" },
  { platform: "whatsapp", color: "#25d366" },
  { platform: "gmail", color: "#EA4335" },
];

export const otherColors = [
  "#D0E8FF",
  "#FED0EE",
  "#FD9CED",
  "#B48AD6",
  "#589F6F",
  "#F09D51",
  "#A9F4D0",
  "#FDCF9F",
  "#DBAEFF",
  "#FBE38E",
  "#008BEE",
];

const ProtocolReport = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedPackageType, setSelectedPackageType] = useState<
    EPackageType | []
  >([]);
  const [selectedCircuitId, setSelectedCircuitId] = useState<
    ISelectOption | []
  >([]);

  const [message, setMessage] = useState<string>("");

  const handleChangeCircuitId = (value: ISelectOption | []) => {
    setSelectedCircuitId(value);
  };

  return (
    <div className="page-container">
      <MainLoader show={loading} />
      <CustomBreadcrumb
        items={[
          { path: "/", title: "Home" },
          { path: "/serviceLineUp", title: "Service Line-up" },
          { path: "", title: "Protocol Report" },
        ]}
      />

      <Title>Protocol Report</Title>

      <ProductAndCircuitIdSelector
        selectedCircuitId={selectedCircuitId}
        selectedPackageType={selectedPackageType}
        setSelectedPackageType={setSelectedPackageType}
        handleChangeCircuitId={handleChangeCircuitId}
        className="mt-1"
        isWithBroadband={false}
      />

      {selectedPackageType.length > 0 && (
        <NoneBroadbandReport
          broadbandOrCircuitId={(selectedCircuitId as ISelectOption).value}
          setLoading={setLoading}
          setMessage={setMessage}
        />
      )}

      <AlertModal
        show={!!message}
        variant="error"
        buttons={[
          {
            text: "Ok",
            onClick: () => setMessage(""),
            variant: "success",
          },
        ]}
      >
        {message}
      </AlertModal>
    </div>
  );
};

export default ProtocolReport;
